import * as ActionTypes from './actionTypes'

export const omnitec_fetchOrganizationsSuccess = data => ({
    type: ActionTypes.OMNITEC_ORGANIZATIONS_FETCH_SUCCESS,
    data: [...data]
})

export const omnitec_fetchOrganizationsFailure = error => ({
    type: ActionTypes.OMNITEC_ORGANIZATIONS_FETCH_FAILURE,
    data: error
})

export const omnitec_saveOrganizationsSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_ORGANIZATIONS_SAVE_SUCCESS,
        data
    }
}

export const omnitec_saveOrganizationsFailure = error => ({
    type: ActionTypes.OMNITEC_ORGANIZATIONS_SAVE_FAILURE,
    data: error
})

export const omnitec_updateOrganizationsSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_ORGANIZATIONS_UPDATE_SUCCESS,
        data
    }
}

export const omnitec_updateOrganizationsFailure = error => {
    return {
        type: ActionTypes.OMNITEC_ORGANIZATIONS_UPDATE_FAILURE,
        data: error
    }
}

export const omnitec_deleteOrganizationsSuccess = ourId => {
    return {
        type: ActionTypes.OMNITEC_ORGANIZATIONS_DELETE_SUCCESS,
        data: ourId
    }
}

export const omnitec_deleteOrganizationsFailure = error => {
    return {
        type: ActionTypes.OMNITEC_ORGANIZATIONS_DELETE_FAILURE,
        data: error
    }
}

export const omnitec_setCurrentOrganization = data => {
    return {
        type: ActionTypes.OMNITEC_CURRENT_ORGANIZATION_CHANGE,
        data
    }
}

export const omnitec_fetchLocksSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_LOCKS_FETCH_SUCCESS,
        data
    }
}

export const omnitec_fetchLocksFailure = error => {
    return {
        type: ActionTypes.OMNITEC_LOCKS_FETCH_FAILURE,
        data: error
    }
}

export const omnitec_fetchPrivateRoomsSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_PRIVATE_ROOMS_FETCH_SUCCESS,
        data
    }
}

export const omnitec_fetchPrivateRoomsFailure = error => {
    return {
        type: ActionTypes.OMNITEC_PRIVATE_ROOMS_FETCH_FAILURE,
        data: error
    }
}

export const omnitec_fetchCommonAreaSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_COMMON_AREA_FETCH_SUCCESS,
        data
    }
}

export const omnitec_fetchCommonAreaFailure = data => {
    return {
        type: ActionTypes.OMNITEC_COMMON_AREA_FETCH_SUCCESS,
        data
    }
}

export const omnitec_fetchEasymsCategoriesSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_EASYMS_CATEGORIES_FETCH_SUCCESS,
        data
    }
}

export const omnitec_fetchEasymsCategoriesFailure = error => {
    return {
        type: ActionTypes.OMNITEC_EASYMS_CATEGORIES_FETCH_FAILURE,
        data: error
    }
}

export const omnitec_createPrivateRoomsSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_PRIVATE_ROOMS_CREATE_SUCCESS,
        data
    }
}

export const omnitec_createPrivateRoomsFailure = error => {
    return {
        type: ActionTypes.OMNITEC_PRIVATE_ROOMS_CREATE_FAILURE,
        data: error
    }
}

export const omnitec_createCommonAreaSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_COMMON_AREA_CREATE_SUCCESS,
        data
    }
}

export const omnitec_createCommonAreaFailure = error => {
    return {
        type: ActionTypes.OMNITEC_COMMON_AREA_CREATE_FAILURE,
        data: error
    }
}

export const omnitec_deletePrivateRoomsSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_PRIVATE_ROOMS_DELETE_SUCCESS,
        data
    }
}

export const omnitec_deletePrivateRoomsFailure = error => {
    return {
        type: ActionTypes.OMNITEC_PRIVATE_ROOMS_DELETE_FAILURE,
        data: error
    }
}

export const omnitec_deleteCommonAreaSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_COMMON_AREA_DELETE_SUCCESS,
        data
    }
}

export const omnitec_deleteCommonAreaFailure = error => {
    return {
        type: ActionTypes.OMNITEC_COMMON_AREA_DELETE_FAILURE,
        data: error
    }
}

export const omnitec_fetchEncodersSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_ENCODERS_FETCH_SUCCESS,
        data
    }
}

export const omnitec_fetchEncodersFailure = error => {
    return {
        type: ActionTypes.OMNITEC_ENCODERS_FETCH_FAILURE,
        data: error
    }
}

export const omnitec_createEncodersSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_ENCODERS_CREATE_SUCCESS,
        data
    }
}

export const omnitec_createEncodersFailure = error => {
    return {
        type: ActionTypes.OMNITEC_ENCODERS_CREATE_FAILURE,
        data: error
    }
}

export const omnitec_deleteEncodersSuccess = data => {
    return {
        type: ActionTypes.OMNITEC_ENCODERS_DELETE_SUCCESS,
        data
    }
}

export const omnitec_deleteEncodersFailure = error => {
    return {
        type: ActionTypes.OMNITEC_ENCODERS_DELETE_FAILURE,
        data: error
    }
}



// WEBPACK FOOTER //
// ./src/actions/omnitecActions.js